import { useLocalization } from '@components/Localization'
import { Box, breakpoints } from '@gassan-ui'
import { Icon } from '@rolex-ui'
import React, { FC } from 'react'
import styled from 'styled-components'

const IconCircle = styled.div`
  width: 36px;
  height: 36px;
  background: transparent;
  border-radius: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${p => p.theme.rolex.colors.primary};
  background: white;
  transition: all 0.3s ease-in-out;
  @media screen and (min-width: ${breakpoints.large}) {
    border-radius: 17.5px;
    margin-right: 12px;
    width: 40px;
    height: 40px;
  }
`

const RowLink = styled.a`
  transition: color 0.2s ease-in-out;
  display: flex;
  flex-wrap: wrap;
  margin: 0 10px;
  align-items: center;
  font-size: 14px;

  @media screen and (min-width: ${breakpoints.large}) {
    margin: 8px 0;
  }

  span {
    transition: all 0.3s ease-in-out;
  }

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      span {
        opacity: 0.3;
      }

      ${IconCircle} {
        background: ${p => p.theme.rolex.colors.primary};
        color: white;
      }
    }
  }
`

interface Props {
  phoneNumber: string
  directionsUrl: string
  detailSlug: string
}

const CtaButtons: FC<Props> = ({ phoneNumber, directionsUrl, detailSlug }) => {
  const { messages, lang } = useLocalization()

  const handlePhoneClick = (e, href: string) => {
    e.preventDefault()
    if (window.innerWidth < 769) {
      ;['staging', 'production'].includes(process.env.NEXT_PUBLIC_STAGE) &&
        // @ts-ignore
        _satellite.track('contactCall')
    }
    window.location.href = href
  }

  const handleDirectionsClick = (e, href: string) => {
    e.preventDefault()
    if (['staging', 'production'].includes(process.env.NEXT_PUBLIC_STAGE)) {
      // @ts-ignore
      _satellite.track('getDirections')
    }
    window.open(href, '_blank')
  }

  return (
    <Box display="flex" as="ul" justifyContent={'center'} flexDirection={'row'}>
      <RowLink
        onClick={e => handlePhoneClick(e, `tel:${phoneNumber}`)}
        title={`${messages.rolex.cta.call} ${phoneNumber}`}
      >
        <IconCircle>
          <Icon size={20} icon="phone"></Icon>
        </IconCircle>
      </RowLink>
      <RowLink
        onClick={e => handleDirectionsClick(e, directionsUrl)}
        title={messages.rolex.cta.getDirections}
        target="blank"
      >
        <IconCircle>
          <Icon size={20} icon="directions"></Icon>
        </IconCircle>
      </RowLink>
      <RowLink href={`/${lang}/rolex/contact/${detailSlug}`} title={messages.rolex.cta.moreDetails}>
        <IconCircle>
          <Icon size={20} icon="plus"></Icon>
        </IconCircle>
      </RowLink>
    </Box>
  )
}

export default CtaButtons
